import { SPACES } from "../lib/spaces";
import { imgSrc } from "../lib/gallery";
import { Reveal } from "./Reveal";

const SPANS = [
  "col-span-2 row-span-2 md:col-span-4",
  "md:col-span-2 row-span-2",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-2",
];

export function Spaces() {
  return (
    <section id="spaces" className="py-20 sm:py-24" data-testid="spaces">
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs sm:text-sm uppercase tracking-[0.22em] text-burgundy font-medium">
              <span className="inline-block h-2 w-2 rounded-full bg-brass" aria-hidden="true" />
              Made for your space
            </p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-forest">
              One of one, for wherever you hang your ideas.
            </h2>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-6 gap-4 auto-rows-[170px] sm:auto-rows-[200px]">
          {SPACES.map((s, i) => (
            <Reveal
              key={s.id}
              delay={i * 0.06}
              className={`${SPANS[i]} relative rounded-2xl overflow-hidden group shadow-tuft`}
            >
              <div className="relative h-full w-full" data-testid={`space-card-${s.id}`}>
                <img
                  src={imgSrc(s.img, 900)}
                  alt={s.alt}
                  width={900}
                  height={600}
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest/85 via-forest/20 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-4">
                  <p className="font-serif text-lg sm:text-xl text-ivory leading-tight">{s.name}</p>
                  <p className="text-xs sm:text-sm text-ivory/75 mt-0.5">{s.caption}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
